import { Link } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';

function AuthControls() {
  const { isAuthenticated, user, logout, loading } = useApp();

  return (
    <div style={{ position: 'fixed', top: 16, right: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
      {loading ? (
        <span>Loading...</span>
      ) : isAuthenticated ? (
        <>
          {user?.displayName && <span>{user.displayName}</span>}
          <button onClick={logout}>Logout</button>
        </>
      ) : (
        <Link to="/login">Login</Link>
      )}
    </div>
  );
}

export default AuthControls;

